/**
 * SEO "Platforms": horizontal card slider with arrows, generated dots and mouse drag.
 * Each track is marked data-platforms-track and names its dots container in data-dots.
 */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-platforms-track]').forEach(function (track) {
        var dotsContainer = track.dataset.dots ? document.getElementById(track.dataset.dots) : null;

        var wrapper = track.closest('.platforms-slider-wrapper');
        if (wrapper) {
            var getStep = function () {
                var firstCard = track.querySelector('.platform-card');
                return firstCard ? firstCard.offsetWidth + 24 : 360;
            };
            var prevBtn = wrapper.querySelector('.prev-btn');
            var nextBtn = wrapper.querySelector('.next-btn');
            if (prevBtn) {
                prevBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    track.scrollBy({ left: -getStep(), behavior: 'smooth' });
                });
            }
            if (nextBtn) {
                nextBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    track.scrollBy({ left: getStep(), behavior: 'smooth' });
                });
            }
        }

        var cards = track.querySelectorAll('.platform-card');
        if (!cards.length) return;

        // Calculate valid scroll stops so we don't render unused dots
        function updateDots() {
            if (!dotsContainer) return [];
            var maxScroll = track.scrollWidth - track.clientWidth;
            var stops = [];

            if (maxScroll > 10) {
                var trackLeft = track.getBoundingClientRect().left;
                cards.forEach(function (card) {
                    var scrollPos = track.scrollLeft + (card.getBoundingClientRect().left - trackLeft);
                    if (scrollPos < maxScroll - 15) stops.push(scrollPos);
                });
                stops.push(maxScroll);
            }

            dotsContainer.innerHTML = '';
            if (stops.length > 1) {
                dotsContainer.style.display = 'flex';
                stops.forEach(function (stopPos, idx) {
                    var btn = document.createElement('button');
                    btn.type = 'button';
                    btn.className = 'platforms-dot' + (idx === 0 ? ' is-active' : '');
                    btn.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
                    btn.addEventListener('click', function (e) {
                        e.preventDefault();
                        track.scrollTo({ left: stopPos, behavior: 'smooth' });
                    });
                    dotsContainer.appendChild(btn);
                });
            } else {
                dotsContainer.style.display = 'none';
            }
            return stops;
        }

        var stops = updateDots();
        window.addEventListener('resize', function () {
            stops = updateDots();
        });

        // Update active dot on scroll
        var scrollTimeout;
        track.addEventListener('scroll', function () {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(function () {
                if (!dotsContainer || !stops || stops.length <= 1) return;

                var closestIdx = 0;
                var minDiff = Infinity;
                stops.forEach(function (stopPos, idx) {
                    var diff = Math.abs(track.scrollLeft - stopPos);
                    if (diff < minDiff) {
                        minDiff = diff;
                        closestIdx = idx;
                    }
                });

                dotsContainer.querySelectorAll('.platforms-dot').forEach(function (d, i) {
                    d.classList.toggle('is-active', i === closestIdx);
                });
            }, 50);
        }, { passive: true });

        // Mouse drag to slide
        var isDown = false;
        var startX = 0;
        var scrollLeftVal = 0;
        var isDraggingMoved = false;

        track.querySelectorAll('img, a').forEach(function (el) {
            el.setAttribute('draggable', 'false');
        });

        track.addEventListener('mousedown', function (e) {
            isDown = true;
            isDraggingMoved = false;
            startX = e.clientX - track.getBoundingClientRect().left;
            scrollLeftVal = track.scrollLeft;
        });
        track.addEventListener('mouseleave', function () {
            isDown = false;
            track.classList.remove('is-dragging');
        });
        track.addEventListener('mouseup', function () {
            isDown = false;
            setTimeout(function () { track.classList.remove('is-dragging'); }, 50);
        });
        track.addEventListener('mousemove', function (e) {
            if (!isDown) return;
            var walk = (e.clientX - track.getBoundingClientRect().left - startX) * 1.5;
            if (Math.abs(walk) > 5) {
                isDraggingMoved = true;
                track.classList.add('is-dragging');
            }
            if (isDraggingMoved) {
                e.preventDefault();
                track.scrollLeft = scrollLeftVal - walk;
            }
        });

        // Prevent link click when dragging
        track.addEventListener('click', function (e) {
            if (isDraggingMoved) {
                e.preventDefault();
                e.stopPropagation();
                isDraggingMoved = false;
            }
        }, true);
    });
});
